export const FETCH_DAY_BP = 'FETCH_DAY_BPS';
export const FETCH_DAY_BP_FETCHING = 'FETCH_DAY_BPS_FETCHING';
export const FETCH_DAY_BP_SUCCESS = 'FETCH_DAY_BPS_SUCCESS';
export const FETCH_DAY_BP_FAIL = 'FETCH_DAY_BPS_FAIL';

export const FETCH_52_WEEKS_BP = 'FETCH_52_WEEKS_BPS';
export const FETCH_52_WEEKS_BP_FETCHING = 'FETCH_52_WEEKS_BPS_FETCHING';
export const FETCH_52_WEEKS_BP_FAIL = 'FETCH_52_WEEKS_BPS_FAIL';
export const FETCH_52_WEEKS_BP_SUCCESS = 'FETCH_52_WEEKS_BPS_SUCCESS';
export const FETCH_52_WEEKS_BP_REPORT = 'FETCH_52_WEEKS_BPS_REPORT';
export const FETCH_52_WEEKS_BP_REPORT_FETCHING = 'FETCH_52_WEEKS_BPS_REPORT_FETCHING';
export const FETCH_52_WEEKS_BP_REPORT_FAIL = 'FETCH_52_WEEKS_BPS_REPORT_FAIL';
export const FETCH_52_WEEKS_BP_REPORT_SUCCESS = 'FETCH_52_WEEKS_BPS_REPORT_SUCCESS';

export const FETCH_MULTIPLE_DAYS_BP = 'FETCH_MULTIPLE_DAYS_BPS';
export const FETCH_MULTIPLE_DAYS_BP_FETCHING = 'FETCH_MULTIPLE_DAYS_BPS_FETCHING';
export const FETCH_MULTIPLE_DAYS_BP_SUCCESS = 'FETCH_MULTIPLE_DAYS_BPS_SUCCESS';
export const FETCH_MULTIPLE_DAYS_BP_FAIL = 'FETCH_MULTIPLE_DAYS_BPS_FAIL';

export const SET_CURRENT_BP_PAGE_DATE = 'SET_CURRENT_PAGE_DATE';
export const SET_CURRENT_BP_TAB = 'SET_CURRENT_BP_TAB';

export const DELETE_BP_ENTRY = 'DELETE_BP_ENTRY';
export const DELETING_BP_ENTRY = 'DELETING_BP_ENTRY';
export const DELETING_BP_SUCCESS = 'DELETING_BP_SUCCESS';
export const DELETING_BP_FAIL = 'DELETING_BP_FAIL';

export const CLEAN_UP_BP_DATA = 'CLEAN_UP_BP_DATA';

export const ADD_BPM = 'ADD_BPM';
export const ADD_BPM_FAIL = 'ADD_BPM_FAIL';
export const ADD_BPM_START = 'ADD_BPM_START';
export const ADD_BPM_SUCCESS = 'ADD_BPM_SUCCESS';

export const FETCH_LATEST_BP = 'FETCH_LATEST_BP';
export const FETCH_LATEST_BP_FAIL = 'FETCH_LATEST_BP_FAIL';
export const FETCH_LATEST_BP_SUCCESS = 'FETCH_LATEST_BP_SUCCESS';
export const FETCH_LATEST_BP_FETCHING = 'FETCH_LATEST_BP_FETCHING';

export const UPDATE_BPM_NOTE = 'UPDATE_BPM_NOTE';
export const UPDATE_BPM_NOTE_START = 'UPDATE_BPM_NOTE_START';
export const UPDATE_BPM_NOTE_SUCCESS = 'UPDATE_BPM_NOTE_SUCCESS';
export const UPDATE_BPM_NOTE_FAIL = 'UPDATE_BPM_NOTE_FAIL';
